import React from 'react';

interface ScopingBadgeProps {
  scoping: string;
}

const SCOPING_BADGE_MAP: Record<string, { label: string; color: string; bg: string }> = {
  self: { label: 'Personal', color: '#6d28d9', bg: '#ede9fe' },
  scoped_hr: { label: 'HR', color: '#0369a1', bg: '#e0f2fe' },
  global_hr: { label: 'Organization', color: '#0e7490', bg: '#cffafe' },
  manager: { label: 'Team', color: '#047857', bg: '#d1fae5' },
  executive: { label: 'Executive', color: '#b45309', bg: '#fef3c7' },
  admin: { label: 'Admin', color: '#7e22ce', bg: '#f3e8ff' },
  learn_admin: { label: 'Learn Admin', color: '#0369a1', bg: '#dbeafe' },
  unit_head: { label: 'Unit Head', color: '#065f46', bg: '#d1fae5' },
  trainer: { label: 'Trainer', color: '#9333ea', bg: '#f3e8ff' },
  internal_trainer: { label: 'Internal Trainer', color: '#7c3aed', bg: '#ede9fe' },
  external_trainer: { label: 'External Trainer', color: '#a855f7', bg: '#faf5ff' },
};

/**
 * ScopingBadge
 *
 * Renders a small pill badge that reflects the data scope (self, manager, HR, etc.)
 * of a widget. Extracted from WidgetWrapper's header section (lines 873–909).
 */
export const ScopingBadge: React.FC<ScopingBadgeProps> = ({ scoping }) => {
  const badge = SCOPING_BADGE_MAP[scoping] ?? {
    label: scoping.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
    color: '#4b5563',
    bg: '#f3f4f6',
  };

  return (
    <span
      style={{
        padding: '1px 6px',
        borderRadius: '4px',
        fontSize: '10px',
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        backgroundColor: badge.bg,
        color: badge.color,
        opacity: 0.8,
      }}
    >
      {badge.label}
    </span>
  );
};
